import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Web3Service } from '../web3.service';
import { UserService } from '../user.service';
import { regex } from '../regex';

@Component({
	selector: 'narwhalia-register',
	templateUrl: './register.component.html',
	styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
	registerForm: FormGroup;

	constructor(
		private formBuilder: FormBuilder,
		private toastr: ToastrService,
		private userService: UserService,
		private router: Router,
		private web3Service: Web3Service,
		private translateService: TranslateService
	) {
		this.registerForm = this.formBuilder.group({
			nameFormControl: ['', Validators.required],
			emailFormControl: ['', [Validators.required, Validators.pattern(regex.email)]],
			passwordFormControl: [
				'',
				[Validators.pattern(regex.password), Validators.required]
			],
			passwordAgainFormControl: ['', Validators.required],
			walletFormControl: ['', Validators.required],
			agreementFormControl: ['', Validators.requiredTrue]
		});
	}

	ngOnInit() {
		this.web3Service.getAddress()
			.then(address => {
				const walletFormControl = this.registerForm.get('walletFormControl');
				walletFormControl.setValue(address);
			});
	}

	onPasswordChange() {
		if (this.registerForm.get('passwordFormControl').value === '') {
			this.registerForm.get('passwordAgainFormControl').setValue('');
		}
	}

	register() {
		const {
			nameFormControl,
			emailFormControl,
			walletFormControl,
			passwordFormControl,
			passwordAgainFormControl
		} = this.registerForm.getRawValue();

		if (passwordFormControl !== passwordAgainFormControl) {
			this.translateService.get('form.error.notMatchingPw').subscribe(translatedText => this.toastr.error(translatedText));
		} else {
			this.userService.register(nameFormControl, emailFormControl, passwordFormControl, walletFormControl).subscribe(() => {
				this.router.navigate(['']);
			});
		}
	}
}
